// Liens Stripe Payment Links publics (paiement direct, sans inscription)
// Générés via stripe.PaymentLink.create — voir /app/backend/setup_stripe.py
export const STRIPE_LINK_SCAN_20 = "https://buy.stripe.com/28EdRa2H11Ki7he8e3gIo01";
export const STRIPE_LINK_SUB_200 = "https://buy.stripe.com/00w7sMchB4Wu0SQambgIo02";
